import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ProfileGateway } from 'src/app/application/gateway/ProfileGateway';
import { SecurityGateway } from 'src/app/application/gateway/SecurityGateway';
import { BasicUser } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css'],

})
export class AdminDashboardComponent implements OnInit {
  displaySidebar = false

  items: MenuItem[] = []

  sideMenuItems: MenuItem[] = [
    {
      label: 'Salir',
      icon: 'pi pi-fw pi-sign-out',
      command: () => { this.logout() }
    }
  ]

  profile: BasicUser | undefined

  materialIconsReady = false;

  notificationsMenuVisible: boolean = false;

  hasGrayBg: boolean = false;
  selectedMenuItem: string = '';

  urlSegment: string | null = null;

  constructor(private _router: Router,
    private _messageService: MessageService,
    private _authService: AuthGateway,
    private _securityService: SecurityGateway,
    public readonly translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.configureMenus()
    this.profile = this._authService.getUser()

    if (this._router.url === "/admin-manage-program-orders" || this._router.url === "/admin-manage-orders") {
      this.hasGrayBg = true;
    }

    this._router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        this.checkSelectedSection(event.url)
      }
      else {
        let ev: any = event;
        if (ev?.routerEvent?.url) this.checkSelectedSection(ev?.routerEvent?.url)
      }
    });
  }

  private configureMenus() {
    this.translate.get([
      'HomeHeader.AdminMenu.UserPanelItem',
      'HomeHeader.AdminMenu.MarketplaceTitle',
      'HomeHeader.AdminMenu.ProgramTitle',
      'HomeHeader.AdminMenu.OrdersItem',
      'HomeHeader.AdminMenu.ProgramOrdersItem',
      'HomeHeader.AdminMenu.ExportOffersItem',
      'HomeHeader.AdminMenu.DownloadedDocumentsItem',
      'HomeHeader.AdminMenu.QualityTitle',
      'HomeHeader.AdminMenu.PortAirportTitle',
      'HomeHeader.AdminMenu.CountriesTitle',
      'HomeHeader.AdminMenu.QCReviewsItem',
      'HomeHeader.AdminMenu.ReportsTitle',
      'HomeHeader.AdminMenu.MasterLoadItem',
      'HomeHeader.AdminMenu.ProgramsReport',
      'HomeHeader.AdminMenu.AssignedDocumentsReport',
      'HomeHeader.AdminMenu.UsersTitle',
      'HomeHeader.AdminMenu.UserAdministrationItem',
      'HomeHeader.AdminMenu.InvitationCodesItem',
      'HomeHeader.AdminMenu.UserManagementItem',
      'HomeHeader.AdminMenu.ConfigurationTitle',
      'HomeHeader.AdminMenu.SpeciesItem',
      'HomeHeader.AdminMenu.ForwardersItem',
      'HomeHeader.AdminMenu.CustomAgentsItem',
      'HomeHeader.AdminMenu.BulkUploadsTitle',
      'HomeHeader.AdminMenu.PalletsProgramItem',
      'HomeHeader.AdminMenu.PreBLItem',
      'HomeHeader.AdminMenu.ConsigneeNotifierAdminItem',
      'HomeHeader.AdminMenu.CreateProgramsFile',
      'HomeHeader.AdminMenu.UpdateProgramsFile',
      'HomeHeader.AdminMenu.InvoicesItem',
      'HomeHeader.AdminMenu.CreateInvoiceItem',
      'HomeHeader.AdminMenu.InvoiceList',
      'HomeHeader.AdminMenu.DispatchPalletStockItem',
    ]).subscribe({
      next: (translations) => {
        this.items = [
          {
            label: translations['HomeHeader.AdminMenu.UserPanelItem'],
            icon: 'material-symbols person-icon',
            routerLink: ['/' + Routes.adminUserPanelPage]
          },
          {
            label: translations['HomeHeader.AdminMenu.MarketplaceTitle'],
            styleClass: 'panel-subtitle',
            disabled: true,
          },
          {
            label: translations['HomeHeader.AdminMenu.OrdersItem'],
            icon: 'material-symbols orders-icon',
            routerLink: ['/' + Routes.adminManageOrderPage]
          },
          {
            label: translations['HomeHeader.AdminMenu.ExportOffersItem'],
            icon: 'material-symbols sell-icon',
            routerLink: ['/' + Routes.adminMarketplaceExportOfferPage]
          },
          {
            label: translations['HomeHeader.AdminMenu.ProgramTitle'],
            styleClass: 'panel-subtitle',
            disabled: true,
          },
          {
            label: translations['HomeHeader.AdminMenu.ProgramOrdersItem'],
            icon: 'material-symbols calendar-month-icon',
            routerLink: ['/' + Routes.adminManageProgramOrderPage]
          },
          {
            label: translations['HomeHeader.AdminMenu.DispatchPalletStockItem'],
            icon: 'material-symbols pallet-icon',
            routerLink: ['/' + Routes.adminStockPallet]
          },
          {
            label: translations['HomeHeader.AdminMenu.ExportOffersItem'],
            icon: 'material-symbols sell-icon',
            routerLink: ['/' + Routes.adminProgramExportOfferPage]
          },
          {
            label: translations['HomeHeader.AdminMenu.InvoicesItem'],
            styleClass: 'panel-subtitle',
            items:
            [
              {
                label: translations['HomeHeader.AdminMenu.InvoiceList'],
                icon: 'material-symbols receipt-icon',
                routerLink: ['/' + Routes.adminLoadInvoiceList]
              },
              {
                label: translations['HomeHeader.AdminMenu.CreateInvoiceItem'],
                icon: 'material-symbols receipt-icon',
                routerLink: ['/' + Routes.adminLoadInvoice]
              }
            ]
          },
          {
            label: translations['HomeHeader.AdminMenu.DownloadedDocumentsItem'],
            icon: 'material-symbols draft-icon',
            routerLink: ['/' + Routes.adminDownloadedDocumentsPage]
          },
          {
            label: translations['HomeHeader.AdminMenu.QualityTitle'],
            styleClass: 'panel-subtitle',
            items: [
              {
                label: translations['HomeHeader.AdminMenu.QCReviewsItem'],
                icon: 'material-symbols search-check-icon',
                routerLink: ['/' + Routes.adminManageQCReviews]
              }
            ]
          },
          {
            label: translations['HomeHeader.AdminMenu.ReportsTitle'],
            styleClass: 'panel-subtitle',
            items: [
              {
                label: translations['HomeHeader.AdminMenu.MasterLoadItem'],
                icon: 'material-symbols table-view-icon',
                routerLink: ['/' + Routes.adminMasterLoadPage]
              },
              {
                label: translations['HomeHeader.AdminMenu.ProgramsReport'],
                icon: 'material-symbols calendar-month-icon',
                routerLink: ['/' + Routes.adminProgramsReport]
              },
              {
                label: translations['HomeHeader.AdminMenu.AssignedDocumentsReport'],
                icon: 'material-symbols draft-icon',
                routerLink: ['/' + Routes.adminAssignedDocumentsReport]
              }
            ]
          },
          /* {
            label: translations['HomeHeader.AdminMenu.DataTitle'],
            styleClass: 'panel-subtitle',
            items: [
              {
                label: translations['HomeHeader.AdminMenu.PortAirportTitle'],
                icon: 'material-symbols search-check-icon',
                routerLink: ['/' + Routes.adminPortsAirportsData]
              },
              {
                label: translations['HomeHeader.AdminMenu.CountriesTitle'],
                icon: 'material-symbols search-check-icon',
                routerLink: ['/' + Routes.adminCountriesData]
              }
            ]
          }, */
          {
            label: translations['HomeHeader.AdminMenu.UsersTitle'],
            styleClass: 'panel-subtitle',
            items: [
              {
                label: translations['HomeHeader.AdminMenu.UserAdministrationItem'],
                icon: 'material-symbols group-icon',
                routerLink: ['/' + Routes.adminUsers]
              },
              {
                label: translations['HomeHeader.AdminMenu.InvitationCodesItem'],
                icon: 'material-symbols person-add-icon',
                fragment: 'invitacion',
                routerLink: ['/' + Routes.adminInvitationCodes]
              },
              {
                label: translations['HomeHeader.AdminMenu.UserManagementItem'],
                icon: 'material-symbols manage-accounts-icon',
                fragment: 'solicitudes',
                routerLink: ['/' + Routes.adminInvitationCodes]
              },
            ],
          },

          {
            label: translations['HomeHeader.AdminMenu.ConfigurationTitle'],
            styleClass: 'panel-subtitle',
            items: [
              {
                label: translations['HomeHeader.AdminMenu.PortAirportTitle'],
                icon: 'material-symbols boat-bus-icon',
                routerLink: ['/' + Routes.adminPortsAirportsData]
              },
              {
                label: translations['HomeHeader.AdminMenu.CountriesTitle'],
                icon: 'material-symbols globe-location-pin-icon',
                routerLink: ['/' + Routes.adminCountriesData]
              },
              {
                label: translations['HomeHeader.AdminMenu.SpeciesItem'],
                icon: 'material-symbols nutrition-icon',
                routerLink: ['/' + Routes.adminSpecies]
              },
              {
                label: translations['HomeHeader.AdminMenu.ForwardersItem'],
                icon: 'material-symbols policy-icon',
                routerLink: ['/' + Routes.adminForwarder]
              },
              {
                label: translations['HomeHeader.AdminMenu.CustomAgentsItem'],
                icon: 'material-symbols local-police-icon',
                routerLink: ['/' + Routes.adminCustomAgent]
              },
            ]
          },
          {
            label: translations['HomeHeader.AdminMenu.BulkUploadsTitle'],
            styleClass: 'panel-subtitle',
            items: [
              {
                label: translations['HomeHeader.AdminMenu.PalletsProgramItem'],
                icon: 'material-symbols pallet-icon',
                routerLink: ['/' + Routes.adminUploadPalletsProgram ]
              },
              {
                label: translations['HomeHeader.AdminMenu.PreBLItem'],
                icon: 'material-symbols article-icon',
                routerLink: ['/' + Routes.adminUploadPreBl ]
              },
              {
                label: translations['HomeHeader.AdminMenu.ConsigneeNotifierAdminItem'],
                icon: 'material-symbols assignment-ind-icon',
                routerLink: ['/' + Routes.adminUploadConsigneeNotifier ]
              },
              {
                label: translations['HomeHeader.AdminMenu.CreateProgramsFile'],
                icon: 'material-symbols assignment-ind-icon',
                routerLink: ['/' + Routes.adminUploadCreatePrograms ]
              },
              {
                label: translations['HomeHeader.AdminMenu.UpdateProgramsFile'],
                icon: 'material-symbols edit-square-icon',
                routerLink: ['/' + Routes.adminUploadUpdatePrograms ]
              }
            ]
          }
        ]
      },
      error: (_) => {}
    })
  }

  checkSelectedSection(url: string) {
    // Se asigna estilo unselected-section para diferenciar ítems con misma url pero
    // diferente section para navegación por fragments
    this.urlSegment = url;

    if (url.includes("#invitacion") || url.includes("#solicitudes")) {
      this.items?.forEach((el: MenuItem) => {
        el.items?.forEach((item: MenuItem) => {
          if (item.fragment && `${item.routerLink?.[0]}#${item.fragment}` !== url) {
            item.styleClass = item.styleClass + ' unselected-section'
          }
          else {
            item.styleClass = item.styleClass?.replace(' unselected-section', '')
          }
        })
      })
      this.items = JSON.parse(JSON.stringify(this.items))
    }
  }

  get userCompleteName(): string {
    if(this.profile) {
      return this.profile.contactName
    }
    return ''
  }

  goToNotifications() {
    this._router.navigate(['/' + Routes.adminNotifications])
  }

  goToUserContactInfo() {
    this._router.navigate(['/' + Routes.adminContactInfo])
  }

  onClickMenuOption(name: string) {
    this.selectedMenuItem = name;
    if (name === 'account') {
      this.goToUserPanel();
    }
    else {
      this.logout();
    }
  }

  goToUserPanel() {
    this._router.navigate(['/' + Routes.adminUserPanelPage])
  }

  logout(): void {
    this._securityService.doLogout().subscribe({
      next: (v) => {
        this._authService.logout()
        this._router.navigate([Routes.login])
      },
      error: (e) => {
        console.log(e)
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudo cerrar sesión correctamente.' });
      },
      complete: () => {
        console.info('Logout successfully')
      }
    })
  }
}
